import React from 'react';
import { resultTimeToCustomCopyMapping } from '../../util';
import { StyledBody } from '../../CSSstyles';

type Props = {
  inHouseResultTime: string;
  sendOutResultTime: string;
};

const BothTypesOfResultTimeBulletPoints = ({ inHouseResultTime, sendOutResultTime }: Props) => {
  const hasBothTypesOfResultTimeData = inHouseResultTime && sendOutResultTime;

  if (!hasBothTypesOfResultTimeData) return null;

  return (
    <>
      <li>
        <StyledBody>
          {`For tests analyzed onsite, turnaround time for results is ${resultTimeToCustomCopyMapping[inHouseResultTime].substring}`}
        </StyledBody>
      </li>

      <li>
        <StyledBody>
          {`For tests analyzed offsite, turnaround time for results is ${resultTimeToCustomCopyMapping[sendOutResultTime].substring}.`}
        </StyledBody>
      </li>
    </>
  );
};

export default BothTypesOfResultTimeBulletPoints;
